enum SourceType {
  Google = 'google',
  SafeYT = 'safeyt'
}

export { SourceType }
